import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface HealthArea {
  id: string;
  name: string;
}

const HEALTH_AREAS_QUERY_KEY = ["health-areas"] as const;

async function fetchHealthAreas(): Promise<HealthArea[]> {
  const { data, error } = await supabase
    .from("health_areas")
    .select("id, name")
    .eq("is_active", true)
    .order("display_order");

  if (error) throw error;
  return data ?? [];
}

export function useHealthAreas() {
  return useQuery({
    queryKey: HEALTH_AREAS_QUERY_KEY,
    queryFn: fetchHealthAreas,
    staleTime: 5 * 60 * 1000,
  });
}


